module.exports = __webpack_public_path__ + "media/images/static/top/urban/center_photo_mobile-664a2081730bb5836bdf1b8ac5c7b2d0.png";